/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".address-block[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{margin-bottom:4px;line-height:100%}agm-map[_ngcontent-%COMP%]{height:150px;width:100%!important}.linehight[_ngcontent-%COMP%]{line-height:15px!important}"];
export { styles as styles };

